import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker';
import custom from '@/f1/custom';

import { api } from '@/f1/service';
import Language from './language';

//restful api
// import { wsfinder as wf } from '@/f1/service/api';

//i18n_data
import fields from './i18n_data'
import i18n_data from '@/component/i18n_data';

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  adv : false,
  sk : '', sv : '', skt : '', opt : { },
})

export default {
  components : { DatePicker, Language },
  data: () => {
    return {
      custom,
      selected: 1,
      so : default_opt()
    }
  },
  computed: {
    fields() { return fields.i18n_fields[this.i18n]; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    rowCount: function() { return this.so.totalRows || 0; }
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk,
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      var search = { target: 'hash', cmd : 'list',limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [{name : 'is_del', value: false, op : '='}], or: [], sort: [{ name: 'id', op : 'desc'}] } }
      if(ctx.sortBy) { this.search.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim()) { search.body.and = [ { name : 'hash', value : `${this.so.sv}`, op : '=' } ] }
      if(so.sk && so.sv) {
        const value = so.sv.replace(/\*/g, '%');
        for(let key of so.sk.split(',')) {
          search.body.or.push({"name": key, "value": `%${value}%`, "op": 'like' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'is_alive' : search.body.and.push({name: 'is_alive', value: value, op: '=' }); break;
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          // default: this.search.body.and.push({name: key, value: value, op: /[%\*]/.test(value) ? 'like' : '=' }); break;
        }
      }

      return api.wsfinder.WSFinder(search).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` :  e.data.message ? e.data.message : e.statusText) );
      //return wf.hash.list(search).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
    },
    detail: function(item) { this.$router.push(`hash/${item.id}`); },
    hideList: function(e) { this.show = !e; console.log('hash.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') }
  },
  created: function() {   console.log('hash.list.vue', 'created'); },
  destroyed: function() { console.log('hash.list.vue', 'destroyed'); },
  mounted: function() { console.log('hash.list.vue', 'mounted'); },
}
